export const SHOP_THE_ROOM = "plp:shop the room detail"
export const PROMO_TILE = "promo tiles"
export const LIST_PRICE = "List"
